import React, { ReactNode } from "react";
import { OcRoleFilterHeaderView } from "./role-filter-header-view";
import { useRoleFilterHeader as useRoleFilterHeaderDI } from "./use-role-filter-header";
import { IconifyIcon } from "@iconify/react";

// TODO f unit tests, storybook

export interface OcRoleFilterHeaderProps {
  opened?: boolean;
  handleOpen?: () => void;
  disabled?: boolean;
  id?: string;
  noButton?: boolean;
  title?: string;
  icon?: string | IconifyIcon;
  titleExtra?: ReactNode;
  useRoleFilterHeader?: typeof useRoleFilterHeaderDI;
}

export const OcRoleFilterHeader: React.FC<OcRoleFilterHeaderProps> = ({
  opened,
  handleOpen,
  disabled,
  id = "collapse-header",
  noButton,
  title = "OC_FILTERING",
  icon = "mdi:account",
  titleExtra,
  useRoleFilterHeader = useRoleFilterHeaderDI,
}) => {
  const { translatedTitle } = useRoleFilterHeader({
    title,
  });
  return (
    <OcRoleFilterHeaderView
      opened={opened}
      handleOpen={handleOpen}
      disabled={disabled}
      id={id}
      noButton={noButton}
      title={translatedTitle}
      icon={icon}
      titleExtra={titleExtra}
    />
  );
};
